<!-- eslint-disable -->
<template>
  <div id="device">
    <Grid
      ref="grid"
      :style="{ height: '300px' }"
      :data-items="filteredData"
      :selected-field="selectedField"
      :columns="columns"
      :filterable="true"
      :filter="filter"
      :sortable="true"
      :sort="sort"
      @filterchange="filterChange"
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange"
      @rowclick="onRowClick"
      @sortchange="sortChange"
      :filter-cell-render="filterRender"
    >
      <template v-slot:filterSlotTemplate="{ props, methods }">
        <div>
          <input
            type="text"
            :value="props.value"
            @input="
              (ev) => {
                props.onChange({
                  operator: 'contains',
                  field: props.field,
                  value: ev.target.value,
                  syntheticEvent: ev,
                });
              }
            "
            style="width: 85px"
          />
          <button
            @click="
              (ev) => {
                props.onChange({
                  operator: '',
                  field: '',
                  value: '',
                  event: ev,
                });
              }
            "
          >
            Clear
          </button>
        </div>
      </template>
      >
    </Grid>
  </div>
</template>
<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import { UserStore } from "@/store/modules/userstore"
import { DeviceStore } from "@/store/modules/devicestore"
import { ProtokollStore } from "@/store/modules/protokollstore";

export default {
  name: "Devices",
  components: {
    Grid: Grid,
  },
  data: function () {
    return {
      filter: {},
      //     logic: "and",
      //     filters: [
      //         { field: "UnitPrice", operator: "neq", value: 2 }
      //     ]
      // },
      sort: [{ field: "nameGeraet", dir: "asc" }],
      selectedField: "selected",
      filteredData: [],
      originData: [],
      staticColumns: [
        {
          field: "idBereich",
          title: "IdBereich",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "fkMandant",
          title: "fkMandant",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "idGeraet",
          title: "IdGeraet",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "nameGeraet",
          title: "NameGeraet",
          filterCell: "filterSlotTemplate",
          width: "200px",
        },
        {
          field: "hinweis",
          title: "Hinweis",
          filterCell: "filterSlotTemplate",
          width: "250px",
        },
        {
          field: "monitoringCode",
          title: "Monitoring-Code",
          filterCell: "filterSlotTemplate",
          width: "200px",
        },
        {
          field: "telNrGeraet",
          title: "TelNrGeraet",
          filterCell: "filterSlotTemplate",
          width: "140px",
        },
        {
          field: "imeiNr",
          title: "ImeiNr",
          filterCell: "filterSlotTemplate",
          width: "150px",
        },
      ],
    };
  },
  computed: {
    areAllSelected() {
      return (
        this.filteredData.findIndex((item) => item.selected === false) === -1
      );
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          filterable: false,
          headerSelectionValue: this.areAllSelected,
        },
        ...this.staticColumns,
      ];
    },
  },
  methods: {
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      this.filteredData = this.filteredData.map((item) => {
        return { ...item, selected: checked };
      });
      const selectedDevices = DeviceStore.getDataset(this.$store)
      selectedDevices.devices = []
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          selectedDevices.devices.push(item);
        }
      });
      DeviceStore.setDataSet(this.$store,selectedDevices)
    },
    onSelectionChange(event) {
      this.selectionChanged(event)
    },
    selectionChanged( event ) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      const selectedDevices = DeviceStore.getDataset(this.$store)
      //selectedDevices.devices.splice(0, selectedDevices.devices.length);
      selectedDevices.devices = []
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          selectedDevices.devices.push(item);
        }
      });
      DeviceStore.setDataSet(this.$store,selectedDevices)
    },
    onRowClick(event) {
      this.selectionChanged(event)
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    // async getProtocolTypes() {
    //   try {
    //     const response = await apiPost("ComponentView/viewKomponenteGeraetProtokollTyp", {
    //         userId: this.$store.getters["userstore/getUser"]
    //       });       
    //     let temp = [];
    //     for (let i=0; i<response.length; i++) {
    //       temp.push(response[i].idProtokollTyp)
    //     }
    //     this.$store.commit("protokollstore/setDataSet", temp)
    //     this.getData();
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async getData() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }

      const protokollTypen = this.$store.getters["protokollstore/getDataSet"];
      console.log(protokollTypen);
      const protokollFilter = [];
      for (let i = 0; i < protokollTypen.length; i++) {
        if ( protokollTypen[i].isChecked) {
          protokollFilter.push(protokollTypen[i].idProtokollTyp);
        }
      }

      console.log(protokollFilter);

        const temp = await apiPost("ComponentView/viewKomponenteGeraet", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: areas,
        protokollTypen: protokollFilter

      });
      this.filteredData = temp.map((item) => {
        return { ...item, selected: false };
      });
      this.originData = temp.map((item) => {
        return { ...item, selected: false };
      });
    },
  },
  created() {
    this.getData();
    
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "areastore/addDataSet") {
        this.getData();
      }
       if (mutation.type === "protokollstore/setDataSet") {
        this.getData();
      }
    });
  },
  beforeUnmount() {
    this.unsubscribe();
  },
};
</script>
<style scoped>
</style>